<template>
  <div :style="{ minHeight: minHeight }" class="loading-container">
    <div v-if="isAto">
      <img src="/media/images/ato-loading.gif" style="width: 120px;height: auto" alt="">
    </div>
    <div v-if="!isAto" class="loadingio-spinner-double-ring-nq4q5u6dq7r">
      <div class="loading-softinyalms" style="background-image: url('/media/slogo.png')">
        <div></div>
        <div></div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultLoading",
  props: {
    gif: {
      required: false,
      type: String,
      default: 'slogo.png'
    },
    minHeight: {
      required: false,
      type: String,
      default: '470px'
    }
  },
  computed: {
    isAto() {
      const subdomain = window.location.hostname;
      return subdomain === 'ato.softinya.com' || subdomain === 'akademi.atonet.org.tr';
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: inherit;
  background-color: rgba(255, 255, 255, 0.9);
  position: relative;
  z-index: 1000;
}

@keyframes loading-softinyalms {
  0% {
    transform: rotate(0)
  }
  100% {
    transform: rotate(360deg)
  }
}

.loading-softinyalms {
  background-repeat: no-repeat;
  background-position: center;
  align-content: center;
  background-size: 65%;
}

.loading-softinyalms div {
  box-sizing: border-box !important
}

.loading-softinyalms > div {
  position: absolute;
  width: 94px;
  height: 94px;
  top: 3px;
  left: 3px;
  border-radius: 50%;
  border: 4px solid #000;
  border-color: #00add2 transparent #00add2 transparent;
  animation: loading-softinyalms 3s linear infinite;
}

.loading-softinyalms > div:nth-child(2), .loading-softinyalms > div:nth-child(4) {
  width: 84px;
  height: 84px;
  top: 8px;
  left: 8px;
  animation: loading-softinyalms 3s linear infinite reverse;
}

.loading-softinyalms > div:nth-child(2) {
  border-color: transparent #23d2ff transparent #23d2ff
}

.loading-softinyalms > div:nth-child(3) {
  border-color: transparent
}

.loading-softinyalms > div:nth-child(3) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}

.loading-softinyalms > div:nth-child(3) div:before, .loading-softinyalms > div:nth-child(3) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 4px;
  height: 4px;
  top: -4px;
  left: 41px;
  background: #00add2;
  border-radius: 50%;
  box-shadow: 0 90px 0 0 #00add2;
}

.loading-softinyalms > div:nth-child(3) div:after {
  left: -4px;
  top: 41px;
  box-shadow: 90px 0 0 0 #00add2;
}

.loading-softinyalms > div:nth-child(4) {
  border-color: transparent;
}

.loading-softinyalms > div:nth-child(4) div {
  position: absolute;
  width: 100%;
  height: 100%;
  transform: rotate(45deg);
}

.loading-softinyalms > div:nth-child(4) div:before, .loading-softinyalms > div:nth-child(4) div:after {
  content: "";
  display: block;
  position: absolute;
  width: 4px;
  height: 4px;
  top: -4px;
  left: 36px;
  background: #23d2ff;
  border-radius: 50%;
  box-shadow: 0 80px 0 0 #23d2ff;
}

.loading-softinyalms > div:nth-child(4) div:after {
  left: -4px;
  top: 36px;
  box-shadow: 80px 0 0 0 #23d2ff;
}

.loadingio-spinner-double-ring-nq4q5u6dq7r {
  display: block;
  margin: 0 auto;
  align-self: center;
  width: 95px;
  height: 95px;
  overflow: hidden;
  background: none;
}

.loading-softinyalms {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(0.95);
  backface-visibility: hidden;
  transform-origin: center;
}

.loading-softinyalms div {
  box-sizing: content-box;
}
/* [ldio] generated by https://loading.io */

</style>
